import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "../components/ui/button";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t, setLanguage } = useLanguage();
  const processed = useRef(false);
  const [state, setState] = useState({ loading: true, message: "" });

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        if (data.user?.language) setLanguage(data.user.language);
        const home =
          data.user.role === "admin"
            ? "/admin"
            : data.user.role === "reviewer"
            ? "/reviewer"
            : "/agent";
        // Clean URL fragment then navigate
        window.history.replaceState(null, "", "/auth/callback");
        navigate(home, { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "";
        const msg =
          detail === "Pending approval"
            ? t("auth_callback_pending")
            : detail || t("err_generic");
        setState({ loading: false, message: msg });
      }
    })();
  }, [navigate, setUser, setLanguage, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="auth-callback">
      <div className="bg-white border border-slate-200 rounded-lg p-10 shadow-sm max-w-md w-full text-center space-y-4">
        {state.loading ? (
          <>
            <div className="mx-auto h-10 w-10 border-2 border-[#0A2540] border-t-transparent rounded-full animate-spin" />
            <p className="text-slate-500" data-testid="auth-callback-loading">
              {t("auth_callback_processing")}
            </p>
          </>
        ) : (
          <>
            <h2 className="font-display text-2xl font-medium text-[#0A2540]">
              {t("register_success_title")}
            </h2>
            <p className="text-slate-500" data-testid="auth-callback-message">
              {state.message}
            </p>
            <Button
              onClick={() => navigate("/login", { replace: true })}
              className="bg-[#0A2540] hover:bg-[#051626] text-white"
              data-testid="auth-callback-back-button"
            >
              {t("auth_callback_back")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
